import React from "react";
import "bootstrap/dist/js/bootstrap.min.js";
import { isResellerDomain } from "../../../CommonComponents/Utils";

export default class ProductDetailFaqWidget extends React.Component<{}> {
  render() {
    return <div className="AccordionFAQ"></div>;
  }
}
